<template>
  <div class="blk_form">
    <div class="form_header">
      <h3 class="form_title icon-">メールお問い合わせ</h3>
      <div class="form_flow">
        <p class="step active"><span class="step_num">1</span><br><span class="step_state">ご入力</span></p>
        <p class="step"><span class="step_num">2</span><br><span class="step_state">ご確認</span></p>
        <p class="step"><span class="step_num">3</span><br><span class="step_state">送信完了</span></p>
      </div>
    </div>
    <div class="form_contents">
      <p class="form_discription">
        <span class="input_disc">必須項目をご記入いただき、「入力内容を確認する」ボタンを押してください。</span>
        <span class="confirm_disc">この内容でよろしければ送信するボタンを押してください。</span>
      </p>
      <dl class="form_block require">
        <dt class="form_label">お名前</dt>
        <dd class="form_area"><input type="text" class="form_parts" name="name" id="name"></dd>
        <dd class="form_value">empty</dd>
        <dd class="form_text">お名前をご入力ください</dd>
        <!-- <dd class="form_error">お名前をご入力ください</dd> -->
      </dl>
      <dl class="form_block require">
        <dt class="form_label">メールアドレス</dt>
        <dd class="form_area"><input type="text" class="form_parts" name="mail" id="mail"></dd>
        <dd class="form_value">empty</dd>
        <dd class="form_text">記入例：example@abcd.co.jp</dd>
      </dl>
      <dl class="form_block require">
        <dt class="form_label">電話番号</dt>
        <dd class="form_area"><input type="text" class="form_parts" name="tel" id="tel"></dd>
        <dd class="form_value">empty</dd>
        <dd class="form_text">記入例：09012345678</dd>
      </dl>
      <dl class="form_block require">
        <dt class="form_label">お問い合わせ内容</dt>
        <dd class="form_area"><textarea class="form_parts" name="message" id="message" cols="30" rows="10"></textarea></dd>
        <dd class="form_value">empty</dd>
        <dd class="form_text">診療内容・治療の流れ・ご予約に関することなど<br>お気軽にお問い合わせください。</dd>
      </dl>
      <div class="form_complete">
        <p class="complete_title">送信完了</p>
        <p class="complete_text">
          この度はお問い合わせメールをお送りいただきありがとうございます。
        </p>
        <p class="complete_text">
          後ほど、ご連絡をさせていただきますので、今しばらくお待ちくださいますようよろしくお願い申し上げます。<br>
        </p>
        <p class="complete_text">
          なお、しばらくたっても返信がない場合は、ご入力いただいたメールアドレスに誤りがある場合がございます。 <br>
        </p>
        <p class="complete_text">
          その際は、お手数ではございますが再度送信いただくか、お電話にてご連絡いただけますと幸いです。
        </p>
      </div>
      <!-- /.form_complete -->
      <div class="form_btns">
        <div class="col"><button class="btn btn_radius btn_arrow_r icon- btn_confirm" id="confirm" disabled>送信内容を確認する</button></div>
        <div class="col"><button class="btn btn_radius btn_arrow_r icon- btn_back" id="back">戻る</button></div>
        <div class="col"><button class="btn btn_radius btn_arrow_r icon- btn_submit" id="submit">送信する</button></div>
        <div class="col"><button class="btn btn_radius btn_arrow_r icon- btn_home" id="home">HOMEへ戻る</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Form',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
